export const fetchStatsMeta = payload => ({
    type: 'FETCH_STATS_META',
    payload
});